import React from 'react';
import './ViewMeetingModalSkeleton.css';

/**
 * Skeleton loader for view meeting modal
 */
const ViewMeetingModalSkeleton = () => {
  return (
    <div className="vms-skeleton-wrapper">
      <div className="vms-skeleton-body">
        {/* Title */}
        <div className="vms-skeleton-group full-width">
          <div className="vms-skeleton-label" />
          <div className="vms-skeleton-field" />
        </div>

        {/* Description */}
        <div className="vms-skeleton-group full-width">
          <div className="vms-skeleton-label" />
          <div className="vms-skeleton-textarea" />
        </div>

        {/* DateTime Row */}
        <div className="vms-skeleton-datetime-row">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="vms-skeleton-group">
              <div className="vms-skeleton-label" />
              <div className="vms-skeleton-field" />
            </div>
          ))}
        </div>

        {/* Location */}
        <div className="vms-skeleton-group full-width">
          <div className="vms-skeleton-label" />
          <div className="vms-skeleton-field" />
        </div>

        {/* Members Section */}
        <div className="vms-skeleton-group full-width">
          <div className="vms-skeleton-label" />
          <div className="vms-skeleton-members-list">
            {Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="vms-skeleton-member-item" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewMeetingModalSkeleton;
